import MasterComponent from '../../../../components/Forms';
import moment from 'moment';
import { MasterConfigs } from '../../../../interfaces/entity';
import { constants } from '../../../../constants/common';
import PdfView from '../../../../components/custom/PDFView';
import { Button, Modal, notification } from 'antd';
import { EyeTwoTone } from '@ant-design/icons';
import { useState } from 'react';
import { getData } from '../../../../actions/apiCall';
import { useDispatch } from 'react-redux';

const RelivingLetter = () => {
  const [pdfURL, setPDFURL] = useState(null);
  const [currentUser, setCurrentUser] = useState(null)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch();

  const intershipConfig: MasterConfigs = {
    api: () => '/relievingLetter',
    title: 'Relieving Certificate',
    isActionTab: true,
    maskClosable: false,
    modalTitle: (action) => action + ' Relieving Certificate',
    getColumns: () => {
      return [
        {
          title: 'Employee Name',
          dataIndex: 'employee',
          key: 'employee',
          render: (value) => {
            return value ? [value.firstName, value.lastName].join(' ') : '';
          },
        },
        {
          title: 'Leaving Date',
          dataIndex: 'leavingDate',
          key: 'leavingDate',
          render: (value) => {
            return moment(value).format('lll');
          },
        },
        {
          title: 'Generated?',
          dataIndex: 'pdfGenrated',
          key: 'pdfGenrated',
          render: (text) => {
            return text ? 'Done' : 'In-Progress';
          }
        },
        {
          title: 'Sent?',
          dataIndex: 'pdfSent',
          key: 'pdfSent',
          render: (text) => {
            return text ? 'Sent' : 'In-Progress';
          }
        },
        {
          title: 'PDF',
          dataIndex: '',
          key: '',
          render: (text, record) => {
            return <Button icon={<EyeTwoTone />} onClick={() => {
              setPDFURL(record?.pdfFile)
              setCurrentUser(record)
            }} type='link' />
          }
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Employee name',
          name: 'employee',
          type: 'select',
          isCombo: true,
          rules: [{ required: true, message: 'Select a Employee' }],
        },
        {
          label: 'Leaving Date',
          name: 'leavingDate',
          type: 'date',
          rules: [{ required: true, message: 'Field is required' }],
        },
        {
          label: 'Email Template',
          name: 'emailTemplate',
          type: 'select',
          isCombo: true,
          rules: [{ required: true, message: 'Field is required' }],
        }
      ];
    },
    combo: [
      {
        name: 'emailTemplate',
        api: '/cms/emailTemplates',
        idKey: '_id',
        render: (text) => text?.name
      },
      {
        name: 'employee',
        api: '/users',
        idKey: '_id',
        render: (text) => constants.GET_FULL_NAME(text)
      },
    ],
    getData: () => ({}),
    actions: [
      { name: 'Add certificate', actionType: 'Add' },
    ],
  };


  const sendMail = async () => {
    try {
      setLoading(true)
      const apiUrl = '/relievingLetter/send/mail/' + currentUser._id
      const resData = await dispatch(getData(apiUrl))
      if (resData) {
        notification.success({
          message: 'Mail sent Successfully',
        })
        setPDFURL(null)
        setCurrentUser(null)
      } else {
        notification.error({
          message: 'Failed to send mail'
        })
      }
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }

  return <>
    <Modal
      width={1000}
      cancelText={"Close"}
      okText={"Send Mail"}
      okButtonProps={{ loading: loading }}
      maskClosable={false}
      onOk={() => sendMail()}
      title={"Internship Certificate"}
      open={pdfURL}
      onCancel={() => {
        setPDFURL(null)
        setCurrentUser(null)
      }}
    >
      <PdfView url={`${process.env.FILE_URL}${pdfURL}`} />
    </Modal >
    <MasterComponent config={intershipConfig} />
  </>

}
export default RelivingLetter

